/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import { exchange, currencies } from '../utilities/constants';
import { formatNumber, formatNumberWithComma } from '../utilities/formatHelpers';
import { useRate } from '../utilities/sharedHooks/rates';
import { USER_PREFERENCES } from '../utilities/sharedQueries';
import CurrencyIcon from './CurrencyIcon';

const Wallet = ({ data, mainScreen, useableWallets = [], className = 'bg-light', ...props }) => {
  const { data: userPref } = useQuery(USER_PREFERENCES);
  const fiatCurrency = userPref?.displayCurrency;

  const coin = data?.coin?.toUpperCase() || data?.currency_code?.toUpperCase();

  const balance = useMemo(() => {
    if (data && data.available_balance) return data.available_balance;
    const wallet = useableWallets.find((w) => w.coin.toUpperCase() === coin);
    return wallet?.available_balance || 0;
  }, [data, useableWallets, coin]);

  const rate = useRate(coin, fiatCurrency);

  const fiatBalance = formatNumber(balance * rate, exchange.FIAT_VALUE);

  const handleSelectWallet = () => {
    props.chooseWallet(data);
    props.openScreen(mainScreen);
  };

  return (
    <div
      role="button"
      tabIndex="0"
      className={`rounded-extra p-3 d-flex flex-row mt-2 ${className}`}
      onClick={handleSelectWallet}
      onKeyDown={handleSelectWallet}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <CurrencyIcon
          currencyCode={coin}
          className="me-2"
          style={{ width: '1.5rem', height: '1.5rem' }}
        />
        <b>{coin?.toUpperCase()}</b>
      </div>
      <span className="text-right flex-fill">
        <b className="text-f5 m-0">
          {formatNumberWithComma(
            formatNumber(
              balance * currencies[coin?.toUpperCase()].conversion,
              currencies[coin?.toUpperCase()].decimal
            )
          )}{' '}
          {coin?.toUpperCase()}
        </b>
        <p className="text-shadow text-f6 m-0">
          {formatNumberWithComma(
            formatNumber(
              fiatBalance * currencies[fiatCurrency.toUpperCase()].conversion,
              exchange.FIAT_VALUE
            )
          )}{' '}
          {fiatCurrency.toUpperCase()}
        </p>
      </span>
    </div>
  );
};

export default Wallet;

Wallet.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  openScreen: PropTypes.func.isRequired,
  chooseWallet: PropTypes.func.isRequired,
  mainScreen: PropTypes.string.isRequired,
  useableWallets: PropTypes.array,
};
